// EditCoursePanel/index.js
import { connect } from 'react-redux';

import { domainType } from '../../constants';

import EditCoursePanel from '../../components/EditCoursePanel';
import {
  openEditCoursePanelDispatch,
  onHandleInputChange,
  submitCourseDispatch,
  fetchRecordsForTheCourseDispatch,
  handleDeleteCourseRecordClickDispatch,
  submitCourseRecordDispatch,
  fetchAllPersonnelsDispatch,
  enableEditCourseRecord,
  handleEditRecordInputChangeDispatch,
  openAddCourseRecordDialogDispatch,
  removeCourseRecordAttachmentEdit,
  fetchExistingAttachmentsForTheCourseRecordDispatch
} from '../../actions';
import { submitMode } from '../../constants';

function mapStateToProps(state, ownProps) {
  return {
    course: state.course.newCourse.item,
    records: state.course.recordsForTheCourse.items,
    record: state.course.newRecord.item,
    personnels: state.personnels.allPersonnels.items,
    userId: state.users.user.item.id,
    isEditRecordEnabled: state.course.editRecord.enable,
    recordBeingEdited: state.course.editRecord.item,
    openAddCourseRecordDialog: state.course.newRecord.openAddCourseRecordDialog,
    allAttachments: state.course.editRecord.item.attachmentFiles,
    branchId: state.branch.branch.item && state.branch.branch.item.id
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    openEditCoursePanel: (open) => {
      dispatch(openEditCoursePanelDispatch(open));
    },
    onHandleInputChange: (value, inputFieldName) => {
      dispatch(onHandleInputChange(value, inputFieldName));
    },
    submitCourse: (course) => {
      const mode = submitMode.UPDATE;
      dispatch(submitCourseDispatch(course, mode));
    },
    fetchRecordsForTheCourse: (courseId) => {
      dispatch(fetchRecordsForTheCourseDispatch(courseId));
    },
    onHandleDeleteCourseRecordClick: (payload) => {
      dispatch(handleDeleteCourseRecordClickDispatch(payload));
    },
    submitRecord: (payload, mode, branchId) => {
      dispatch(submitCourseRecordDispatch(payload, mode, 'edit', branchId));
    },
    fetchAllPersonnels: (branchId) => {
      dispatch(fetchAllPersonnelsDispatch(branchId));
    },
    enableEditCourseRecord: (
      enableEditRecordMode,
      recordId,
      loggedInUserId
    ) => {
      dispatch(enableEditCourseRecord(enableEditRecordMode, recordId));
      dispatch(
        fetchExistingAttachmentsForTheCourseRecordDispatch(
          domainType.COURSE_RECORD,
          recordId,
          loggedInUserId
        )
      );
    },
    onHandleEditRecordInputChange: (value, inputFieldName) => {
      dispatch(handleEditRecordInputChangeDispatch(value, inputFieldName));
    },
    onOpenAddCourseRecordDialog: (open, personnelId, source) => {
      dispatch(openAddCourseRecordDialogDispatch(open, personnelId, source));
    },
    onRemoveAttachment: (attachment) => {
      dispatch(removeCourseRecordAttachmentEdit(attachment));
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(EditCoursePanel);
